<section class="version-overlay">
  <article class="wrapper fadeInDown wrapperAdds" role="dialog" aria-label="Version history">
    <div class="logo-banner fadeIn first">
      <img class="logo" src="../assets/logo-white.png" alt="Novaglobal" />
    </div>
    <div class="version-body">
      <h1 class="text-center text-dark">{{ 'versionHistoryTitle' | translate }}</h1>

      <div class="panel-body">
        <div class="version-list" *ngIf="!loading && !error; else status">
          <div class="version-item" *ngFor="let entry of entries">
            <div class="version-header">
              <span class="version-label">{{ entry.version }}</span>
              <span class="badge">{{ entry.type | translate }}</span>
              <span class="date" *ngIf="entry.date">{{ entry.date }}</span>
            </div>
            <p class="summary">{{ summaryFor(entry) }}</p>
            <ul class="notes" *ngIf="entry.notes?.length">
              <li *ngFor="let note of entry.notes">{{ note }}</li>
            </ul>
          </div>
        </div>
        <ng-template #status>
          <p class="text-center text-dark" *ngIf="loading">Loading…</p>
          <p class="text-center text-dark" *ngIf="error">{{ error }}</p>
        </ng-template>
      </div>

      <div class="divBtn">
        <a class="btnA">
          <div class="btn">
            <input
              class="inputBtn"
              name="close-version"
              [value]="'close' | translate"
              type="button"
              (click)="onClose()"
            />
          </div>
        </a>
      </div>
    </div>
  </article>
</section>
